import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delarlist",
  "use": "icon-delarlist-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delarlist\"><path d=\"M939.1 211.7H530.2c-15.2 0-27.5-12.3-27.5-27.5s12.3-27.5 27.5-27.5h408.9c15.2 0 27.5 12.3 27.5 27.5s-12.3 27.5-27.5 27.5zM939.1 429.2H530.2c-15.2 0-27.5-12.3-27.5-27.5s12.3-27.5 27.5-27.5h408.9c15.2 0 27.5 12.3 27.5 27.5s-12.3 27.5-27.5 27.5zM362.5 183.1v247.4H123V183.1h239.5m15-55H108c-22.1 0-40 17.9-40 40v277.4c0 22.1 17.9 40 40 40h269.5c22.1 0 40-17.9 40-40V168.1c0-22.1-18-40-40-40zM362.5 592.9v247.4H123V592.9h239.5m15-55H108c-22.1 0-40 17.9-40 40v277.4c0 22.1 17.9 40 40 40h269.5c22.1 0 40-17.9 40-40V577.9c0-22.1-18-40-40-40zM939.1 646.7H530.2c-15.2 0-27.5-12.3-27.5-27.5s12.3-27.5 27.5-27.5h408.9c15.2 0 27.5 12.3 27.5 27.5s-12.3 27.5-27.5 27.5zM939.1 864.2H530.2c-15.2 0-27.5-12.3-27.5-27.5s12.3-27.5 27.5-27.5h408.9c15.2 0 27.5 12.3 27.5 27.5s-12.3 27.5-27.5 27.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/delarlist.svg
// module id = DK2a
// module chunks = 59